import { cn as e } from "../shared/utils.js";
import { forwardRef as t } from "react";
import { mergeProps as n } from "@base-ui/react/merge-props";
import { useRender as r } from "@base-ui/react/use-render";
//#region src/skeleton/skeleton.tsx
var i = t(({ className: t, render: i, ...a }, o) => {
	let s = {
		"aria-hidden": !0,
		className: e("skeleton-animation bg-bg-quaternary rounded-md block", t)
	};
	return r({
		defaultTagName: "span",
		props: n(s, a),
		ref: o,
		render: i
	});
});
i.displayName = "Skeleton";
//#endregion
export { i as Skeleton };
